import {dynamicApiCall} from "./dynamicApiCall";

export const ExcelSignupSchool = async (data) => {
  const option = {
    method: 'POST',
    endpoint: '/upload-excel/',
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  }

  const response = await dynamicApiCall(option)

  if (response.status === 200) {
    return response
  } else {
    throw response
  }
};